import './App.css'
import Button from '@mui/material/Button';

function App () {
  return <Button variant='contained'>Hello World</Button>
}

export default App
